import React, { Dispatch, SetStateAction } from "react"
import tw from "twin.macro"
import { getEmojiForReaction } from "."
import { EmojiReaction, QuestionDetailFragment } from "../../graphql/generated/graphql"
import ProfilePhoto, { Width } from "../profilePhoto"
import { AllReactions } from "./allReactions"
import { Modal } from "../modal"

export interface WhoReactedProps {
  question: QuestionDetailFragment
  showAllReactions: boolean
  useEmojiSmall: boolean
  setShowAllReactions: Dispatch<SetStateAction<boolean>>
}

export const WhoReacted = (props: WhoReactedProps) => {
  const { question, setShowAllReactions, showAllReactions, useEmojiSmall } = props
  const { Artist, reactions } = question
  const sourceCommentLikes = question.SourceComment?.likeCount ?? 0
  const discordReactions = question.discordReactionCount ?? 0
  const totalReactions = reactions.length + sourceCommentLikes + discordReactions
  const artistReaction = reactions.find((reaction) => reaction.Reactor.id === Artist.id)

  const emojis = reactions[0]?.ranking.map((emoji, i) => (
    <span
      data-testid={`ranking-${i + 1}-${emoji}`}
      key={i}
      css={useEmojiSmall ? tw`text-lg` : tw`text-xl`}
      aria-label={`ranking ${i + 1} ${emoji}`}
    >
      {emoji && getEmojiForReaction(emoji)}
    </span>
  ))

  const thirdPartyEmojiRxn =
    sourceCommentLikes > 0 || discordReactions > 0 ? (
      <span
        data-testid={`ranking-extern-rxn-emoji`}
        key={`ranking-extern-rxn-heart`}
        css={useEmojiSmall ? tw`text-lg` : tw`text-xl`}
        aria-label={`ranking-extern-rxn-emoji heart`}
      >
        {getEmojiForReaction(EmojiReaction.Heart)}
      </span>
    ) : (
      <></>
    )

  const allReactionsModalProps = {
    show: showAllReactions,
    setShow: setShowAllReactions,
    component: <AllReactions question={question} />,
  }

  return (
    <>
      {totalReactions > 0 && (
        <div tw="flex relative items-center space-x-3 hover:(cursor-pointer)" onClick={() => setShowAllReactions(true)}>
          <div tw="flex -space-x-1 items-center">
            {emojis}
            {thirdPartyEmojiRxn}
            {artistReaction && (
              <div tw="relative" aria-label={`${question.Artist.name} ${artistReaction.emoji}`}>
                <ProfilePhoto
                  name={question.Artist.name ? question.Artist.name : ""}
                  username={question.Artist.username}
                  width={useEmojiSmall ? Width.W20 : Width.W24Reaction}
                  profilePictureUrl={question.Artist.profilePictureUrl}
                />
                <span
                  tw="absolute -right-2 -bottom-1"
                  css={useEmojiSmall ? tw`text-xs` : tw`text-sm`}
                  data-testid="artist-reaction"
                >
                  {getEmojiForReaction(artistReaction.emoji)}
                </span>
              </div>
            )}
          </div>
          <div css={useEmojiSmall ? tw`text-xs` : tw`text-sm`} tw="font-bold text-base-4 hover:(cursor-pointer)">
            <span data-testid="total-reactions" aria-label={`${totalReactions} reactions`}>
              {totalReactions}
            </span>
            {!emojis || emojis.length == 0 ? (
              <span tw="ml-1" css={tw`text-sm`} aria-label={`ranking 1 external reactions`}>
                {getEmojiForReaction(EmojiReaction.Heart)}
              </span>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
      <Modal {...allReactionsModalProps} />
    </>
  )
}
